import { render, staticRenderFns } from "./CategoryListItemComponent.html?vue&type=template&id=006a1a10&scoped=true&"
import script from "./CategoryListItemComponent.js?vue&type=script&lang=js&"
export * from "./CategoryListItemComponent.js?vue&type=script&lang=js&"
import style0 from "./CategoryListItemComponent.scss?vue&type=style&index=0&id=006a1a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a1a10",
  null
  
)

export default component.exports